import React, { createContext, useState, useEffect, useContext } from "react";
import { fetchDetectionProducts } from "../services/ripAPI";
import { AuthContext } from "./AuthContext"; // Adjust the import path as necessary

export const DetectionProductContext = createContext();


export const DetectionProductProvider = ({ children, member, token }) => {
  const [detectionProducts, setDetectionProducts] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const { setGlobalError, apiConfigured, resetTrigger, refreshTrigger } = useContext(AuthContext);

  useEffect(() => {
    const fetchDetectionProductsCall = async () => {
      
      if (!apiConfigured) {
        console.warn('DetectionProductContext: API not yet configured, skipping fetch');
        return;
      }
      
      try {
        const products = await fetchDetectionProducts(member.acct_id);
        setDetectionProducts(products);
      } catch (err) {
        setGlobalError("Failed to fetch detection products");
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    if (apiConfigured && member?.acct_id) {
      fetchDetectionProductsCall();
    } else {
      setLoading(false); // API not configured or no member, no need to fetch
    }
  }, [setGlobalError, apiConfigured, refreshTrigger, member]);

  // Watch for reset trigger from AuthContext
  useEffect(() => {
    if (resetTrigger > 0) {
      resetDetectionProducts();
    }
  }, [resetTrigger]);

  // Watch for refresh trigger from AuthContext (for account switching)
  useEffect(() => {
    if (refreshTrigger > 0 && apiConfigured && member?.acct_id) {
      setLoading(true);
      const fetchDetectionProductsCall = async () => {
        try {
          const products = await fetchDetectionProducts(member.acct_id);
          setDetectionProducts(products);
        } catch (err) {
          setGlobalError("Failed to fetch detection products");
        } finally {
          setLoading(false);
        }
      };
      fetchDetectionProductsCall();
    }
  }, [refreshTrigger, apiConfigured, member, setGlobalError]);

  const resetDetectionProducts = () => {
    setDetectionProducts([]);
    setLoading(true);
  };

  return (
    <DetectionProductContext.Provider value={{ detectionProducts, loading, resetDetectionProducts }}>
      {children}
    </DetectionProductContext.Provider>
  );
};
